import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './MobileBreadcrumbs.module.scss';

const MobileBreadcrumbs = ({ breadcrumbs, handleLink, children }) => {
  const popover = (
    <Popover id={styles['mobile-breadcrumb-popover-container']}>
      <Popover.Content>
        <div className={styles['mobile-breadcrumb-popover']}>
          {breadcrumbs.map((crumb, index) => {
            return (
              <span
                key={crumb.path}
                className={styles['mobile-breadcrumb-popover__text']}
                data-testid={`${crumb.path}-${index}`}
              >
                <Link
                  to={handleLink(crumb.path, crumb.text)}
                  className={styles['mobile-breadcrumb-popover__text--link']}
                >
                  {crumb.text}
                </Link>
              </span>
            );
          })}
        </div>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={popover}
      trigger="click"
      rootClose
    >
      {children}
    </OverlayTrigger>
  );
};

export default MobileBreadcrumbs;
